/**
 * 常量文件
 */

/**
 * 语言键
 */
export const languageKey = 'System.Admin.locale';